import { createContext } from 'react';
import { User } from '../helpers/interfaces';

export const UserContext = createContext<undefined|User>(undefined);
